import { Component, inject, output, ViewEncapsulation } from '@angular/core';
import { ThemeService, ThemeType } from '@service/theme.service';
import { FlowStore } from '@store/flow-store';

export enum FlowActionPanelAction {
    ZOOM_IN = 'ZOOM_IN',
    ZOOM_OUT = 'ZOOM_OUT',
    ONE_TO_ONE = 'ONE_TO_ONE',
    FIT_TO_SCREEN = 'FIT_TO_SCREEN',
    SELECT_ALL = 'SELECT_ALL',
}

@Component({
    selector: 'app-flow-action-panel',
    templateUrl: './flow-action-panel.component.html',
    styleUrl: './flow-action-panel.component.scss',
    standalone: false,
})
export class FlowActionPanelComponent {
    readonly darkTheme = ThemeType.Dark;
    readonly lightTheme = ThemeType.Light;

    constructor(private themeService: ThemeService) {}
    protected readonly store = inject(FlowStore);

    protected get currentTheme() {
        return ThemeType.Light;
    }

    public readonly processAction = output<FlowActionPanelAction>();
    public readonly resetFlow = output<void>();

    protected readonly action = FlowActionPanelAction;
    protected readonly canRemove = this.store.canRemove;

    protected removeSelected(): void {
        this.store.removeSelected();
    }

    protected toggleTheme(theme: ThemeType): void {
        this.themeService.toggle(theme);
    }

    protected reset(): void {
        this.resetFlow.emit();
    }
}
